import React, { useEffect, useMemo, useState } from "react";
import Styles from "./style.module.scss";
import InputField from "@Molecule/InputField";
import Button from "@Atom/Button";
import Table from "@Molecule/Table";
import Modal from "@Atom/Modal";
import {
  getDataNotifLearn,
  sendMessageLearn,
  sendMessageLearnAll,
} from "@Services/admin";
import moment from "moment";
import SuccessNotifModal from "@Molecule/SuccessNotifModal";

export default function LearnNotif() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [data, setData] = useState({
    totalData: 0,
    data: [],
  });

  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);

  const handleFetchData = async () => {
    try {
      setLoading(true);
      const res = await getDataNotifLearn(page, limit,search);
      if (res.status) {
        setData(res);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    handleFetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit,search]);

  const handleSendMessage = async (data) => {
    const payload = {
      data,
      templateId: "classReminder",
    };
    try {
      const res = await sendMessageLearn(payload);
      if (res.status) {
        setSuccess(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSendMessageAll = async () => {
    const payload = {
      templateId: "classReminder",
    };
    try {
      const res = await sendMessageLearnAll(payload);
      if (res.status) {
        setSuccess(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const template = useMemo(() => {
    return {
      data: data.data,
      columns: [
        {
          name: "Name",
          title: "Judul Kelas",
          renderData: (row) => <span>{row.title}</span>,
        },
        {
          name: "Name",
          title: "Tanggal",
          renderData: (row) => <span>{moment().format("LL")}</span>,
        },
        {
          name: "Name",
          title: "Waktu Mulai",
          renderData: (row) => (
            <span>{moment(row.batches[0].startDate).format("HH:MM")}</span>
          ),
        },
        {
          name: "usersheetCount",
          title: "Jml. Peserta",
          renderData: (row) => <span>{row.usersheetCount || "0"}</span>,
        },
        {
          name: "",
          title: "",
          renderData: (row) => (
            <div className={Styles.buttonSendTable}>
              <Button
                text={"Kirim Reminder"}
                endIcon={"document-upload-filled"}
                variant="outlined"
                onClick={() => handleSendMessage([row._id])}
              />
            </div>
          ),
        },
      ],
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, data]);

  return (
    <div className={Styles.container}>
      <div className={Styles.controlSection}>
        <div className={Styles.searchBar}>
          <InputField
            startIcon="search-normal"
            placeholder="Cari Kelas"
            iconSize="20"
            setValue={setSearch}
            value={search}
          />
        </div>
        <div className={Styles.buttonWrapper}>
          <Button
            text={"Kirim Semua"}
            startIcon={"sms-tracking"}
            disabled={data.length < 1}
            onClick={() => handleSendMessageAll()}
          />
        </div>
      </div>
      <div className={Styles.bodySection}>
        <Table
          data={template?.data}
          totalData={data?.totalData}
          totalPage={Math.ceil(data.totalData / limit)}
          columns={template?.columns}
          page={page}
          setPage={setPage}
          className={`${Styles.table} ${
            !template?.data?.length ? Styles.grow : ""
          }`}
          limit={limit}
          setLimit={setLimit}
          withPagination
          withNumbering
          isLoading={loading}
        />
      </div>
      <Modal isOpen={success}>
        <SuccessNotifModal handleClose={() => setSuccess(false)} />
      </Modal>
    </div>
  );
}
